import axios from 'axios';

export async function callLambdaFunction(endpoint, payload) {
  try {
    const response = await axios?.post(endpoint, payload);
    return response?.data;
  } catch (error) {
    const details = error?.response?.data || error?.message || 'Unknown error';
    console.error('Lambda Function Error:', { error, details });
    throw new Error(details?.error || details?.message || String(details));
  }
}
